<template>
  <div 
    class="hero-background">
    <!--
    <img
      :srcset="srcSet"
      :src="srcSetImages['1440']"
      class="hero-background__img">
    -->
    <picture> 
      <source
        v-for="(image, index) of srcSetImages"
        :key="index"
        :media="`(max-width: ${index}px)`"
        :srcset="image">
      <img :src="srcSetImages[1024]">
    </picture>
  </div>
</template>

<script>
export default {
  name: 'HeroBackground',
  props: {
    srcSetImages: {
      type: Object,
      required: true
    }
  },
  computed: {
    srcSet: {
      get () {
        return Object.keys(this.srcSetImages)
          .map(width => parseInt(width, 10))
          .sort((a, b) => b - a)
          .reduce((srcSet, width) => `${srcSet} ${this.srcSetImages[width]} ${width}w,`, '')
          .slice(0, -1)
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./background.scss";
</style>
